import React from 'react';
import CustomDropdown from './CustomDropdown';

/**
 * Status-specific dropdown that separates "Completed" from other statuses.
 * Thin wrapper around CustomDropdown.
 */
export default function StatusDropdown({
  statuses = [],
  value,
  onChange,
  onAddNew,
  disabled = false,
  compact = false,
  tinted = false,
  fullWidth = false,
}) {
  const regularStatuses = statuses.filter(s => s.name?.toLowerCase() !== 'completed');
  const completedStatuses = statuses.filter(s => s.name?.toLowerCase() === 'completed');

  const sections = [
    {
      items: regularStatuses.map(s => ({
        value: s.status_id,
        label: s.name,
        color: s.color,
      })),
    },
  ];

  if (completedStatuses.length > 0) {
    sections.push({
      items: completedStatuses.map(s => ({
        value: s.status_id,
        label: s.name,
        color: s.color,
      })),
    });
  }

  const actions = onAddNew ? [{ label: '+ Add Status', onClick: onAddNew }] : [];

  return (
    <CustomDropdown
      sections={sections}
      value={value}
      onChange={onChange}
      placeholder="Select status"
      disabled={disabled}
      compact={compact}
      tinted={tinted}
      fullWidth={fullWidth}
      actions={actions}
    />
  );
}
